"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=t=>a=>{const{queryKey:r,signal:e}=a;if(Array.isArray(r)){const[,...s]=r;return t(...s,e)}return t(r,e)};exports.withQueryParams=i;
